import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
import { selectEntityState } from '../reducers/entityStatesSlice';
import { actionOnOff } from '../actions/ActionOnOff';
export const EntityOnOff = props => {
    const entityState = useAppSelector(selectEntityState(props.entity.id));
    const dispatch = useAppDispatch();
    if (props.entity.title !== 'onoff' || props.action.title !== 'onoff') {
        return null;
    }
    const value = (entityState === null || entityState === void 0 ? void 0 : entityState.value.type) == 'bool' ? entityState === null || entityState === void 0 ? void 0 : entityState.value.value : undefined;
    let s1, s2;
    if (value === true) {
        s1 = undefined;
        s2 = 'on';
    }
    else if (value === false) {
        s1 = 'off';
        s2 = undefined;
    }
    else {
        s1 = undefined;
        s2 = undefined;
    }
    return (_jsxs("div", { className: "transmitter-buttons lw-button-group", children: [_jsx(DeviceButton2, { state: s1, onClick: () => dispatch(actionOnOff(props.action.id, false)), children: "Av" }), _jsx(DeviceButton2, { state: s2, onClick: () => dispatch(actionOnOff(props.action.id, true)), children: "P\u00E5" })] }));
};
